<div class="benefit-program-container">
  <div [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Ambassadør</mat-label>
      <input
        data-testid="ambassador-name-input"
        formControlName="searchValue"
        matInput
        placeholderText="Navn på ambassadør"
        type="search"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete">
        @for (seller of searchResult(); track seller.userId) {
          <mat-option [value]="seller.fullName" (click)="onSponsorSelected(seller)">
            {{ seller.fullName }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Velg type</mat-label>
      <mat-select formControlName="sponsorType" (selectionChange)="onSponsorTypeChange($event)">
        <mat-option [value]="SponsorType.Ice">Ice</mat-option>
        <mat-option [value]="SponsorType.CustomerService">Kundeservice</mat-option>
        <mat-option [value]="SponsorType.Dealer">Retail</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  @if (isCurrentlySearching()) {
    <app-spinner />
  }
</div>
